export default __webpack_public_path__ + "static/media/smartag.98807540.png";